// src/components/SilverCroaker.jsx
import React, { useRef, useEffect } from 'react';
import '../../../css/swim.css';

export default function SwimmingSilverCroaker({
  width = 120,
  swimDuration = '50s',
  tailDuration = '0.8s',
  minTop = 80,   // default lower lane
  maxTop = 95,
  onClick,
  highlight = false,
  zIndex = 30,
}) {
  const wrapperRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    const w = wrapperRef.current, img = imgRef.current;
    if (!w || !img) return;

    const low = Math.min(minTop, maxTop);
    const high = Math.max(minTop, maxTop);
    const top = low + Math.random() * (high - low);

    // wrapper moves horizontally
    w.style.position = 'absolute';
    w.style.left = '0';
    w.style.top = `${top}%`;
    w.style.width = `${width}px`;
    w.style.animationDuration = swimDuration; // .swim-boto-wrapper
    w.style.zIndex = String(zIndex);

    // image wags tail
    img.style.animationDuration = tailDuration; // .swim-boto-img
  }, [swimDuration, tailDuration, minTop, maxTop, width, zIndex]);

  const url = '/images/animals/0_5m/predator/silver_croaker_head.png';

  const onKeyDown = (e) => {
    if (!onClick) return;
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); }
  };

  return (
    <div
      ref={wrapperRef}
      className={`swim-boto-wrapper ${highlight ? 'inline-block ring-4 ring-yellow-300 rounded-full scale-110' : ''}`}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label="silver croaker"
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <img
        ref={imgRef}
        src={url}
        alt="Silver Croaker"
        className="swim-boto-img"
        draggable={false}
        style={{ width: `${width}px`, display: 'block', cursor: onClick ? 'pointer' : 'default' }}
        onError={(e) => console.warn('[Silver Croaker] image failed to load:', e.currentTarget.src)}
      />
    </div>
  );
}
